<app-icon *ngIf="liveStatus" name="cloud" color="var(--jet-black)" data-analytics="device-online-icon-cloud-on"></app-icon>
<app-icon *ngIf="!liveStatus" name="cloudOff" color="gray" data-analytics="device-online-icon-cloud-off"></app-icon>
